module.exports = __webpack_public_path__ + "static/media/elaina2.cb23f968.png";